@mixin device() {
  @media (max-width: 767.99px) {
    @content;
  }
}

@mixin desktop() {
  @media (min-width: 768px) {
    @content;
  }
}

:host {
  --header-height: 50px;
  --text-light-gray: #525252;
  $brand-darkblue: #001D4C;
  $brand-blue: #1251A4;

  display: flex;
  flex-direction: column;
  // height: 100vh;


  .scroll-y {
    overflow-y:scroll;
  }

  .text-light{
    color: var(--text-light-gray) !important;
  }

  .sub-header {
    font-size: .75rem;
    padding-bottom: 1rem;
    
    a {
      color: var(--primary);
    }
    a.active {
      color: var(--text-light-gray);
    }
  }

  .h-100 {
    height: 100%;
  }

  .sticky {
    position:sticky;
    top: 0;
  }

  #descending {
    border-right: 1px solid var(--gray-200);
    border-left: 1px solid var(--gray-200);
    margin: 0 5px;
    padding: 0 5px;
  }

  .flex {
    display:flex;
    flex-flow: row;

    h1 {
      flex: 1 1 auto; 
      align-self: center;
    }

    .search-bar {
      flex: 2 2 auto;
      align-self: center;
    }

    .type-ahead-wrapper input {
      background-color: none;
    }
  }
  .location-list-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .header-container {
    height: 100px;
    background-color: var(--gray-blue);
    margin-bottom: 2rem;
    @include device {
      height: auto;
      padding: 0 10px 10px 10px;
    }
    header {
      height: 100%;
    }

    h1 {
      font-weight: bold;
    }
  }
  h1 {
    font-weight: normal;
    font-size: 28px;
    margin: 1rem 0 .5rem;

    a {
      font-size: x-small;
    }
  }

  location-map {
    width: 100vw;
    height: calc(100vh - var(--header-height));
    position: fixed;
    top: var(--header-height);
    right:0;
    transform:translateX(100%);
    transition: transform 0.5s ease-in-out; 
    z-index:6000;

    &.show {
      transform: translateX(0);
    }
  }
  .btn-show-map {
    height: 50px;
    width: 200px;
    position: fixed;
    top: 85vh;
    right: calc(50vw - 100px);
    background-color: $brand-blue;
    border-radius: 50px;
    color: white;
    font-size: 1rem;
    z-index: 6001;

    .btn-icon {
      vertical-align: middle;
    }
  }

  loading-indicator {
    flex-basis: 60%;
    flex-shrink: 1;
    max-width: 778px;

    @include device {
      height: 100vh;
    }
  }

  @include device {
    .results-count {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      color: var(--gray-500);
    }
  }

  .locations {
    // display: flex;
    // flex-grow: 1;
    // overflow-y: hidden;
    min-height: 100vh;
    // flex-wrap: wrap;
    // justify-content: space-between;

    .location-header {
      width: 100%;
    }
    .location-list-results {
      border-top: 1px solid var(--gray-200);
    }

    .location-list {
      // overflow-y: scroll;

      padding-bottom: 2rem;

      @include device {
        flex-basis: 100%;
      }

      header {
        position: sticky;
        top: 0;
        z-index: 99;
        border-bottom: 2px solid var(--gray-100);
        background-color: var(--white);
        padding: 1rem 1.5rem;

        @include device {
          padding: .75rem 1rem;
        }
      }

      &-sorting {
        margin: 1rem 0 0;
        font-size: 14px;
        display: flex;
        align-items: center;

        @include device {
          justify-content: space-between;
          margin-top: .5rem;
        }

        .results-count {
          margin-right: auto;
        }

        .results-ordering {
          margin-right: 1rem;

          a {
            color: var(--primary);
            text-decoration: none;

            &+a {
              margin-left: .5rem;
              padding-left: .5rem;
              border-left: 1px solid var(--gray-500);
            }

            &:not(.active):hover {
              text-decoration: underline;
            }

            &.active {
              color: #8E939F; // accessible version // var(--gray-500);
              pointer-events: none;
            }

            // Icon
            position: relative;

            icon-marker {
              position: absolute;
              transform: scale(.8);
              right: -14px;

              @keyframes marker {
                0% {
                  opacity: 1;
                }

                50% {
                  opacity: 0;
                }

                100% {
                  opacity: 1;
                }
              }

              animation: marker 2s ease-in-out infinite;
            }
          }
        }

      }

      &-results {
        padding: 0 1.5rem;
      }
    }

  }

  .button-filters {
    background-color: var(--white);
    border: 2px solid var(--gray-300);

    padding: .25rem .75rem;
    border-radius: .75rem;

    cursor: pointer;

    margin: 0;

    &:hover {
      background-color: var(--gray-300);
    }
  }

  a.clear {
    color: var(--primary);
    margin-left: 10px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .location-details {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    icon-marker {
      margin-right: 1rem;

      @include device {
        display: none;
      }
    }

    p {
      margin-top: 0;
      font-size: 16px;
    }

    a {
      color: var(--primary);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .location-detail {
      display: flex;
      align-items: flex-start;

      flex: 1 1 0;

      @include device {
        flex: 0 0 100%;
      }

      &+.location-detail {
        @include desktop {
          margin-left: 1rem;
          padding-left: 1rem;
          // border-left: 2px solid var(--gray-100);
        }
      }

      &.link {
        align-self: flex-end;
        margin-top: auto;
        flex: 0 0 100%;
        width: 100%;

        border-left: none;
        padding: 0 !important;
        margin-left: 0 !important;
        margin-top: 1rem;

        justify-content: flex-end;

        a {
          display: inline-flex;
          align-items: center;

          span {
            margin-right: 8px;
          }

          @include device {
            flex-grow: 1;
            justify-content: space-between;

            padding: .5rem 1rem;

            background-color: var(--primary);
            color: var(--white);
          }
        }
      }
    }
  }

  .location-schedule-link-container {
    display: flex;
    justify-content: space-between;
    width:100%;
    border: 1px solid #DFDFDF;
    border-left: 2px solid #6DC42A;
    padding: 20px;
    align-items:center;
    margin-top:10px;
    
    p {
      margin: 0;
      font-weight: bold;
    }
    a {
      color: #000;

      &:hover {
        color: #000;
        text-decoration: none;
      }
    }
  }
}